export enum AsyncStatus {
  IDLE = "IDLE",
  LOADING = "LOADING",
  UPDATING = "UPDATING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}
